var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.2002C11.5579 3.2002 11.2 3.55801 11.2 4.0002C11.2 4.44238 11.5579 4.8002 12 4.8002C12.4422 4.8002 12.8 4.44238 12.8 4.0002C12.8 3.55801 12.4422 3.2002 12 3.2002ZM12 5.6002C11.5579 5.6002 11.2 5.95801 11.2 6.4002C11.2 6.84238 11.5579 7.2002 12 7.2002C12.4422 7.2002 12.8 6.84238 12.8 6.4002C12.8 5.95801 12.4422 5.6002 12 5.6002ZM11.9125 7.9877C11.5 8.03301 11.1907 8.38613 11.2 8.8002V15.6752L9.76255 14.2377C9.61255 14.0799 9.40474 13.9893 9.18755 13.9877C8.86255 13.9908 8.57192 14.1893 8.45161 14.4908C8.32974 14.7924 8.40474 15.1361 8.63755 15.3627L11.3375 18.0502C11.3485 18.0721 11.361 18.0924 11.375 18.1127L11.4375 18.1627C11.6079 18.3346 11.8454 18.4189 12.086 18.3955C12.3266 18.3705 12.5422 18.2393 12.675 18.0377L15.3625 15.3627C15.6016 15.1705 15.7094 14.8596 15.6407 14.5611C15.5719 14.2611 15.3391 14.0283 15.0391 13.9596C14.7407 13.8908 14.4297 13.9986 14.2375 14.2377L12.8 15.6752V8.8002C12.8032 8.58301 12.7188 8.3752 12.5657 8.22207C12.4125 8.06895 12.2047 7.98457 11.9875 7.9877C11.9625 7.98613 11.9375 7.98613 11.9125 7.9877ZM2.80005 15.2002V19.9627C2.80005 20.6361 3.36411 21.2002 4.03755 21.2002H19.9625C20.636 21.2002 21.2 20.6361 21.2 19.9627V15.2002H19.6V19.6002H4.40005V15.2002H2.80005Z",
    fill: "#666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDisabled);
export default __webpack_public_path__ + "static/media/downloadDisabled.6bcf5cd68a81b8534ec67f963f273217.svg";
export { ForwardRef as ReactComponent };